import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import FAQSection from './components/FAQSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <TopicsSection />
        <AppSection />
        <CardsSection />
        <UpdatesSection />
        <CarouselSection />
        <AboutSection />
        <RankingSection />
        <IndexSection />
        <FAQSection />
        <FeaturesSection />
        <CommentsSection />
        <ContactSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}